document.addEventListener('DOMContentLoaded', () => {
  const sectionContainer = document.querySelector('[data-cart-page]');
  if (!sectionContainer) return;

  const sectionId = sectionContainer.dataset.sectionId;
  let noteTimer = null;

  const getSectionHtml = (sectionHtml) => {
    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    return parsed.querySelector('[data-cart-page]');
  };

  const renderSection = (data) => {
    const html = data.sections?.[sectionId];
    if (!html) return;

    const newContent = getSectionHtml(html);
    if (!newContent) return;

    sectionContainer.innerHTML = newContent.innerHTML;
    updateCartCount(data.item_count ?? 0);
  };

  const screenOverlay = document.querySelector('[data-atc-screen-overlay]');

  const showLoading = () => {
    if (screenOverlay) screenOverlay.classList.add('is-visible');
    sectionContainer.style.pointerEvents = 'none';
  };

  const hideLoading = () => {
    if (screenOverlay) screenOverlay.classList.remove('is-visible');
    sectionContainer.style.pointerEvents = '';
  };

  const handleQuantityChange = async (button, delta) => {
    const line = parseInt(button.dataset.index, 10);
    const input = sectionContainer.querySelector(`[data-quantity-input][data-index="${line}"]`);
    if (!input) return;

    const currentQty = parseInt(input.value, 10);
    const newQty = Math.max(0, Math.min(99, currentQty + delta));
    if (newQty === currentQty) return;

    showLoading();
    try {
      const data = await CartAPI.change(line, newQty, [sectionId]);
      renderSection(data);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-page', cartData: data });
    } catch (error) {
      publish(PUB_SUB_EVENTS.cartError, { source: 'cart-page', error });
    } finally {
      hideLoading();
    }
  };

  const handleRemove = async (button) => {
    const line = parseInt(button.dataset.index, 10);
    showLoading();
    try {
      const data = await CartAPI.change(line, 0, [sectionId]);
      renderSection(data);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-page', cartData: data });
    } catch (error) {
      publish(PUB_SUB_EVENTS.cartError, { source: 'cart-page', error });
    } finally {
      hideLoading();
    }
  };

  const handleNoteChange = (textarea) => {
    clearTimeout(noteTimer);
    noteTimer = setTimeout(async () => {
      try {
        await CartAPI.update({ note: textarea.value });
      } catch (error) {
        publish(PUB_SUB_EVENTS.cartError, { source: 'cart-page', error });
      }
    }, 500);
  };

  sectionContainer.addEventListener('click', (event) => {
    const minusBtn = event.target.closest('[data-quantity-minus]');
    const plusBtn = event.target.closest('[data-quantity-plus]');
    const removeBtn = event.target.closest('[data-remove-item]');
    const checkoutBtn = event.target.closest('[data-checkout-btn]');

    if (minusBtn) {
      handleQuantityChange(minusBtn, -1);
    } else if (plusBtn) {
      handleQuantityChange(plusBtn, 1);
    } else if (removeBtn) {
      handleRemove(removeBtn);
    } else if (checkoutBtn) {
      // NOTE: unreachable in production today — the checkout button markup
      // (cart-footer.liquid / cart.liquid) has no [data-checkout-btn]
      // attribute, so it never matches event.target.closest above; the
      // button's own inline onclick="handleFloCheckoutBtn()" is what
      // actually triggers checkout. Do not add [data-checkout-btn] to the
      // markup without removing that inline onclick first, or
      // handleFloCheckoutBtn() will fire twice per click.
      if (typeof handleFloCheckoutBtn === 'function') {
        handleFloCheckoutBtn();
      }
      // No native-checkout fallback. Shopflo owns checkout, and it already
      // fails open to /checkout itself when its token API errors. Routing here
      // as well would send shoppers to native Shopify checkout whenever the
      // bundle is merely slow to initialise — losing the prepaid discount, COD
      // flow and upsells. The reference theme has no such fallback either.
      // else {
      //   window.location.href = '/cart/checkout';
      // }
    }
  });

  sectionContainer.addEventListener('input', (event) => {
    if (event.target.closest('[data-cart-note]')) {
      handleNoteChange(event.target);
    }
  });

  let refreshPending = false;

  const refreshCartPage = () => {
    if (refreshPending) return;
    refreshPending = true;
    showLoading();
    fetch(`/?sections=${sectionId}`)
      .then((res) => res.json())
      .then((sections) => {
        const html = sections[sectionId];
        if (html) {
          const newContent = getSectionHtml(html);
          if (newContent) sectionContainer.innerHTML = newContent.innerHTML;
        }
        return CartAPI.get();
      })
      .then((cartData) => {
        updateCartCount(cartData.item_count ?? 0);
        if (typeof bauUpdateSavingsBadge === 'function') requestAnimationFrame(bauUpdateSavingsBadge);
        document.dispatchEvent(new CustomEvent('cart:rendered'));
      })
      .catch(() => {})
      .finally(() => {
        hideLoading();
        refreshPending = false;
      });
  };

  subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
    if (data?.source === 'cart-page') return;
    refreshCartPage();
  });

  subscribe(PUB_SUB_EVENTS.cartAdd, () => {
    refreshCartPage();
  });
});
